import axios from 'axios';

// Auth uses the backend's HttpOnly session cookie, which is sent automatically
// because withCredentials is set. We deliberately do not store the JWT in
// localStorage — that would expose it to XSS.
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8000',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    // CSRF defense for cookie-authenticated state-changing requests: a custom
    // header can't be set by a cross-site "simple" request without a CORS
    // preflight, which the backend's origin allowlist rejects.
    'X-Requested-With': 'XMLHttpRequest',
    'X-Schedule-Solo2-Contract': '1',
  },
});

export default api;
